import { useState, useEffect } from 'react';

export const useModalState = (selectedRecord) => {
  const [localRecord, setLocalRecord] = useState(selectedRecord);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showAuthorizerConfirmation, setAuthorizerShowConfirmation] = useState(false);
  const [showuploadAlertDialog, setShowuploadAlertDialog] = useState(false);
  const [showremarkAlertDialog, setShowremarkAlertDialog] = useState(false);
  const [showZoneAlertDialog, setShowZoneAlertDialog] = useState(false);
  const [formDataToSubmit, setFormDataToSubmit] = useState(null);
  const [localRecordStatus, setlocalRecordStatus] = useState();
  const [showPaymentAlertDialog, setShowPaymentAlertDialog] = useState(false);
  const [showSurveyDialog, setShowSurveyDialog] = useState(false);
  const [showSurveyZoneDialog, setShowSurveyZoneDialog] = useState(false);
  const [zoneStatement, setZoneStatement] = useState('');
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [pdfGenerated, setPdfGenerated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [statusText, setStatusText] = useState('');

  const formatDatea = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const todayFormatted = formatDatea(new Date());

  const [surveyFormData, setSurveyFormData] = useState({
    name: selectedRecord.applicantName,
    surveyNo: selectedRecord.surveyNumber,
    village: selectedRecord.village,
    email: selectedRecord.applicantEmail,
    date: todayFormatted,
  });

  // Update local record when selectedRecord changes
  useEffect(() => {
    if (JSON.stringify(selectedRecord) !== JSON.stringify(localRecord)) {
      setLocalRecord(selectedRecord);
    }
  }, [selectedRecord]);

  const handleSurveyInputChange = (e) => {
    const { name, value } = e.target;
    setSurveyFormData((prev) => ({ ...prev, [name]: value }));

    if (name === 'zoneStatement') {
      setZoneStatement(value);
    }
  };

  const handleFieldChange = (field, value) => {
    setLocalRecord(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== 'application/pdf') {
        alert('Only PDF files are allowed');
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        alert('File size must be less than 10MB');
        return;
      }
      setSelectedFile(file);
    }
  };

  return {
    localRecord,
    setLocalRecord,
    selectedFile,
    setSelectedFile,
    showConfirmation,
    setShowConfirmation,
    showAuthorizerConfirmation,
    setAuthorizerShowConfirmation,
    showuploadAlertDialog,
    setShowuploadAlertDialog,
    showremarkAlertDialog,
    setShowremarkAlertDialog,
    showZoneAlertDialog,
    setShowZoneAlertDialog,
    formDataToSubmit,
    setFormDataToSubmit,
    localRecordStatus,
    setlocalRecordStatus,
    showPaymentAlertDialog,
    setShowPaymentAlertDialog,
    showSurveyDialog,
    setShowSurveyDialog,
    showSurveyZoneDialog,
    setShowSurveyZoneDialog,
    zoneStatement,
    setZoneStatement,
    isGeneratingPDF,
    setIsGeneratingPDF,
    pdfGenerated,
    setPdfGenerated,
    isLoading,
    setIsLoading,
    progress,
    setProgress,
    statusText,
    setStatusText,
    surveyFormData,
    setSurveyFormData,
    todayFormatted,
    handleSurveyInputChange,
    handleFieldChange,
    handleFileChange,
    formatDatea
  };
};